import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type Stream from "./Stream";
import type User from "./User";

@Model()
class StreamsUser extends ApplicationRecord {
  static jsonapiType = "streams_users";

  @Attr() accessLevel: string;

  @Attr() archived: boolean;

  @Attr() archivedAt: string;

  @Attr() autoRefresh: boolean;

  @Attr() canEdit: boolean;

  @Attr() position: number;

  @Attr() primary: boolean;

  @Attr() refreshedAt: string;

  @Attr() sharedGroupId: number;

  @BelongsTo() stream: Stream;

  @Attr() streamId: number;

  @Attr() unreadMentionCount: number;

  @BelongsTo() user: User;

  @Attr() userId: number;
}

export default StreamsUser;
